import {createSvgIcon} from '../create-svg-icon';

export const BandcampIcon = createSvgIcon(
  <path d="M0 18.75l7.437-13.5H24l-7.438 13.5H0z" />
);
